<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动</el-breadcrumb-item>
      <el-breadcrumb-item>奖品配置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-input
            v-model="queryInfo.prizeId"
            placeholder="请输入奖品id"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="queryInfo.prizeType"
            placeholder="请选择奖品类型"
            clearable
          >
            <el-option
              v-for="item in queryInfo.prizeTypeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="getPriseList">查询</el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="openDialog">新增</el-button>
        </el-col>
      </el-row>

      <el-table :data="tableInfo.tableData" border>
        <el-table-column
          v-for="(item, index) in tableInfo.columns"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :key="index"
        >
          <template slot-scope="scope">
            <span v-if="item.prop == 'createTime'">
              {{ scope.row[item.prop] | filterTime }}
            </span>
            <span v-else-if="item.prop == 'updateTime'">
              {{ scope.row[item.prop] | filterTime }}
            </span>
            <el-image
              v-else-if="item.prop == 'cover' || item.prop == 'changeCover'"
              :src="scope.row[item.prop]"
              :preview-src-list="[scope.row[item.prop]]"
            >
              <!-- <div slot="error" class="image-slot">
                <span>-</span>
              </div> -->
            </el-image>
            <span v-else-if="item.prop == 'isHave'">
              {{ scope.row[item.prop] | filterIsHave }}
            </span>
            <span v-else-if="item.prop == 'prizeType'">
              {{ scope.row[item.prop] | filterPrizeType }}
            </span>
            <div v-else-if="item.prop == 'operation'">
              <el-button type="primary" @click="openDialog(scope.row)">
                <i class="el-icon-edit"></i>
              </el-button>
            </div>
            <span v-else>
              {{ scope.row[item.prop] }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationInfo.pageNum"
        :page-sizes="[10,30,50]"
        :page-size="paginationInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationInfo.total"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      width="30%"
      :title="dialogInfo.title"
      :visible="dialogInfo.visible"
      @close="dialogInfo.visible = false"
      :destroy-on-close="true"
    >
      <el-form
        ref="prizeForm"
        :model="dialogInfo.formData"
        :rules="dialogInfo.rules"
        :label-position="'right'"
        label-width="130px"
        element-loading-text="正在上传中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form-item
          :label="item.label"
          :prop="item.prop"
          v-for="(item, index) in dialogInfo.formInfo"
          :key="index"
        >
          <!-- 输入框 -->
          <el-input
            v-if="item.type == '1'"
            v-model="dialogInfo.formData[item.prop]"
          ></el-input>
          <!-- 下拉选择奖品类型 -->
          <el-select
            v-else-if="item.type == '2'"
            v-model="dialogInfo.formData[item.prop]"
            placeholder="请选择"
            @change="changeFormInfo"
          >
            <el-option
              v-for="it in item.options"
              :key="it.value"
              :label="it.label"
              :value="it.value"
            >
            </el-option>
          </el-select>
          <!-- 文件、图片 上传 -->
          <el-upload
            v-else-if="item.type == '3'"
            class="upload-demo"
            action=""
            :limit="1"
            :http-request="myUplaod"
            :on-remove="removeFile"
            :data="{ name: item.prop }"
          >
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <!-- 取消/确定按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInfo.visible = false">取 消</el-button>
        <el-button type="primary" @click="addPrize">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 输入框搜索
      queryInfo: {
        prizeId: "", // 活动id
        prizeType: "", // 奖品类型
        prizeTypeArr: [
          { label: "动画", value: 1 },
          { label: "精灵", value: 2 },
          { label: "伏特", value: 3 },
          { label: "VIP", value: 4 },
          { label: "道具", value: 5 },
          { label: "碎片", value: 6 },
        ],
      },

      // 表格数据
      tableInfo: {
        columns: [
          { label: "编号", prop: "id", width: 150, align: "center" },
          { label: "活动id", prop: "activityId", width: 150, align: "center" },
          {
            label: "记录中展示的图",
            prop: "changeCover",
            width: 150,
            align: "center",
          },
          { label: "奖品封面图", prop: "cover", width: 150, align: "center" },
          { label: "天数", prop: "days", width: 150, align: "center" },
          { label: "是否兑换", prop: "isHave", width: 150, align: "center" },
          { label: "奖品id", prop: "prizeId", width: 150, align: "center" },
          { label: "奖品类型", prop: "prizeType", width: 150, align: "center" },
          { label: "数量", prop: "quantity", width: 150, align: "center" },
          { label: "标题", prop: "title", width: 150, align: "center" },
          { label: "伏特值", prop: "volt", width: 150, align: "center" },
          { label: "中奖率", prop: "winningRate", width: 150, align: "center" },
          {
            label: "创建时间",
            prop: "createTime",
            width: 150,
            align: "center",
          },
          {
            label: "最后修改时间",
            prop: "updateTime",
            width: 150,
            align: "center",
          },
          { label: "编辑", prop: "operation", width: 150, align: "center" },
        ],
        tableData: [],
      },

      // 分页数据
      paginationInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      // 弹窗数据
      dialogInfo: {
        title: "添加奖品",
        visible: false,
        formInfo: [
          { type: 1, label: "奖品id", prop: "prizeId" },
          {
            type: 2,
            label: "奖品类型",
            prop: "prizeType",
            options: [
              { label: "动画", value: 1 },
              { label: "精灵", value: 2 },
              { label: "伏特", value: 3 },
              { label: "VIP", value: 4 },
              { label: "道具", value: 5 },
              { label: "碎片", value: 6 },
            ],
          },
          { type: 1, label: "标题", prop: "title" },
          { type: 1, label: "中奖率", prop: "winningRate" },
          { type: 1, label: "伏特值", prop: "volt" },
          { type: 1, label: "活动商品id", prop: "activityGoodsId" },
          { type: 1, label: "天数", prop: "days" },
          { type: 1, label: "活动id", prop: "activityId" },
          { type: 1, label: "数量", prop: "quantity" },
          { type: 3, label: "奖品封面图", prop: "cover" },
          { type: 3, label: "记录中展示的图", prop: "changeCover" },
        ],
        rules: {
          prizeId: [
            { required: true, message: "请输入奖品id", trigger: "blur" },
          ],
          prizeType: [
            { required: true, message: "请选择奖品类型", trigger: "change" },
          ],
          title: [
            { required: true, message: "请输入奖品名称", trigger: "blur" },
          ],
          winningRate: [
            { required: true, message: "请输入中奖概率", trigger: "blur" },
          ],
          cover: [
            { required: true, message: "请上传奖品封面图", trigger: "change" },
          ],
          volt: [
            { required: true, message: "请输入奖品所需伏特", trigger: "blur" },
          ],
          activityGoodsId: [
            { required: true, message: "请输入活动商品id", trigger: "blur" },
          ],
          activityId: [
            { required: true, message: "请输入活动id", trigger: "blur" },
          ],
          changeCover: [
            {
              required: true,
              message: "请上传记录所要展示的图",
              trigger: "change",
            },
          ],
        },
        formData: {},
      },
    };
  },
  mounted() {
    this.getPriseList();
    this.memoFormInfo = this.dialogInfo.formInfo;
  },
  methods: {
    // 获取奖励表格数据
    getPriseList() {
      const params = {
        pageNum: this.paginationInfo.pageNum,
        pageSize: this.paginationInfo.pageSize,
      };
      for (let key in this.queryInfo) {
        if (this.queryInfo[key] && !(this.queryInfo[key] instanceof Array)) {
          params[key] = this.queryInfo[key];
        }
      }

      console.log(params);
      // if(this.queryInfo.activityId){
      //   params.activityId = this.queryInfo.activityId;
      // }
      this.$http.get("/prize/list", { params }).then((res) => {
        if (res.status == 200) {
          this.tableInfo.tableData = res.data.data.result;
          this.paginationInfo.pageNum = res.data.data.currPage;
          this.paginationInfo.pageSize = res.data.data.pageSize;
          this.paginationInfo.total = res.data.data.total;
        }
      });
    },

    // 切换页码
    handleSizeChange(newSize) {
      this.paginationInfo.pageSize = newSize;
      this.getPriseList();
    },

    // 切换每页展示条数
    handleCurrentChange(newPage) {
      this.paginationInfo.pageNum = newPage;
      this.getPriseList();
    },

    // 打开弹窗
    openDialog(row) {
      this.dialogInfo.visible = true;
      if (row.id) {
        this.dialogInfo.title = "修改奖品";
        console.log(row);

        for (let key in row) {
          this.$set(this.dialogInfo.formData, key, row[key]);

          // if(key != 'cover' || key != 'changeCover'){
          //   this.$set(this.dialogInfo.formData, key, row[key]);
          // }
        }
        this.changeFormInfo(row.prizeType);
      } else {
        this.dialogInfo.title = "新增奖品";
        // this.$refs['prizeForm'].resetFields();
        this.dialogInfo.formData = {};
      }
    },

    // 文件上传
    myUplaod(header) {
      if (header.data.name) {
        // console.log(header.file);
        this.dialogInfo.formData[header.data.name] = header.file;
      }
    },

    // 移除文件
    removeFile(file) {
      for (let key in this.dialogInfo.formData) {
        if (
          this.dialogInfo.formData[key] instanceof File &&
          this.dialogInfo.formData[key].uid == file.uid
        ) {
          delete this.dialogInfo.formData[key];
        }
      }
    },

    // 改变表单布局
    changeFormInfo(num) {
      let newFormInfo = this.memoFormInfo;
      if (num == 1 || num == 2 || num == 3 || num == 5) {
        // 类型为动画/精灵/伏特时， 无数量，天数输入框
        newFormInfo = newFormInfo.filter((item) => {
          return item.prop != "days";
        });
      } else if (num == 6) {
        // 类型为碎片时， 有数量， 无天数，
        newFormInfo = newFormInfo.filter((item) => {
          return item.prop != "days";
        });
      }
      this.dialogInfo.formInfo = newFormInfo;
    },

    // 增加奖品
    addPrize() {
      this.$refs["prizeForm"].validate((valid) => {
        if (valid) {
          let interfaceStr = "";
          let formData = new FormData();
          if (this.dialogInfo.title == "新增奖品") {
            // 新增
            for (let key in this.dialogInfo.formData) {
              if (key == "cover" || key == "changeCover") {
                formData.append(key + "File", this.dialogInfo.formData[key]);
              } else {
                formData.append(key, this.dialogInfo.formData[key]);
              }
            }

            interfaceStr = "/prize/insert";
          } else if (this.dialogInfo.title == "修改奖品") {
            // 修改
            const params = this.dialogInfo.formData;
            delete params.createTime;
            delete params.updateTime;
            delete params.isHave;
            for (let key in params) {
              if (key == "cover" || key == "changeCover") {
                formData.append(key + "File", params[key]);
              } else if (params[key] == null) {
                delete params[key];
              } else {
                formData.append(key, params[key]);
              }
            }

            interfaceStr = "/prize/update";
          }
          this.$http.post(interfaceStr, formData).then((res) => {
            console.log(res);
            if (res.status == 200) {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.dialogInfo.visible = false;
                this.getPriseList();
              } else {
                this.$message.error(res.data.message);
              }
            }
          });
        }
      });

      // console.log(this.dialogInfo.formData);
    },
  },
};
</script>

<style lang="less" scoped>
.el-row .el-col-1 {
  margin: 0 10px;
}
/deep/.cell img {
  width: 100%;
}
/deep/.el-dialog {
  min-width: 500px !important;
  margin-top: 5vh !important;
}
</style>
